import { Injectable } from '@angular/core';
import { SupportedLanguage } from '../../i18n';

@Injectable({ providedIn: 'root' })
export class CfContextService {
  public context = '';
  public csrfToken = '';
  public currentDateLanguage = SupportedLanguage.DE;
  public currentLanguage = SupportedLanguage.DE;

  public getUrl(url: string = ''): string {
    return (this.context + url).replace('//', '/');
  }

  public constructor() {
    this.csrfToken = window._csrfToken_;
    this.context = window._context_;
    if (window._currentDateLanguage_ && window._currentDateLanguage_.toLowerCase() === SupportedLanguage.EN.toLowerCase()) {
      this.currentDateLanguage = SupportedLanguage.EN;
    }
    if (window._currentLanguage_ && window._currentLanguage_.toLowerCase() === SupportedLanguage.EN.toLowerCase()) {
      this.currentLanguage = SupportedLanguage.EN;
    }
  }
}
